import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["max", "min", "onChange", "value"];
import { fromString as simpleDateFromString, make as simpleDateMake } from 'foundations-components/transitional/utils/SimpleDate';
import { DateInput as FoundationsDateInput } from 'foundations-components/transitional/components/DateInput';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { jsx as _jsx } from "react/jsx-runtime";
const dateToSimpleDate = date => {
  if (!date) {
    return undefined;
  }
  return typeof date === 'string' ? simpleDateFromString(date, 'yyyy-MM-DD') : simpleDateMake(date.getFullYear(), date.getMonth(), date.getDate());
};
const simpleDateToDate = simpleDate => {
  return new Date(simpleDate.year, simpleDate.month, simpleDate.date);
};
export const InputDate = _ref => {
  var _dateToSimpleDate, _dateToSimpleDate2, _dateToSimpleDate3;
  let {
      max,
      min,
      onChange,
      value
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  const handleOnChange = event => {
    onChange(simpleDateToDate(event.target.value));
  };
  const dateValue = (_dateToSimpleDate = dateToSimpleDate(value)) !== null && _dateToSimpleDate !== void 0 ? _dateToSimpleDate : undefined;
  const maxValue = (_dateToSimpleDate2 = dateToSimpleDate(max)) !== null && _dateToSimpleDate2 !== void 0 ? _dateToSimpleDate2 : undefined;
  const minValue = (_dateToSimpleDate3 = dateToSimpleDate(min)) !== null && _dateToSimpleDate3 !== void 0 ? _dateToSimpleDate3 : undefined;
  return /*#__PURE__*/_jsx(FoundationsDateInput, Object.assign({}, rest, spacingProps, {
    max: maxValue,
    min: minValue,
    onChange: handleOnChange,
    value: dateValue
  }));
};
const InputDateWrapper = props => /*#__PURE__*/_jsx(InputWrapper, Object.assign({}, props));
InputDateWrapper.displayName = 'InputWrapper';
InputDate.Wrapper = InputDateWrapper;